import React from 'react';

import { Stack } from '@mui/system';
import { Typography } from '@mui/material';

import styles from './nocamera.module.scss';

export const NoCamera = () => (
  <Stack className={styles.container} data-testid="component-error-nocamera">
    <Typography variant="h1">Camera cannot be found!</Typography>
    <Typography variant="body1">Please select one from the preview list.</Typography>
  </Stack>
);
